module.exports = __webpack_public_path__ + "img/1-EXPLORA.1213c95c.gif";